import { useState, useCallback } from 'react';

export function useSubmitState() {
  const [submitting, setSubmitting] = useState(false);
  const [submitError, setSubmitErrorState] = useState(null);
  const [success, setSuccessState] = useState(false);

  const startSubmit = useCallback(() => {
    setSubmitting(true);
    setSubmitErrorState(null);
    setSuccessState(false);
  }, []);

  const setSubmitError = useCallback((message) => {
    setSubmitting(false);
    setSubmitErrorState(message);
    setSuccessState(false);
  }, []);

  const setSuccess = useCallback(() => {
    setSubmitting(false);
    setSubmitErrorState(null);
    setSuccessState(true);
  }, []);

  const reset = useCallback(() => {
    setSubmitting(false);
    setSubmitErrorState(null);
    setSuccessState(false);
  }, []);

  return {
    submitting,
    submitError,
    success,
    startSubmit,
    setSubmitError,
    setSuccess,
    reset,
  };
}
